'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import Button from '@classify/react-core-components/Button';
import { alpha } from '@classify/react-core-components/styles';
import { translate } from '@openclassrooms/translations';
import useHeroActions from '../../_hooks/useHeroActions';
type Action = 'start' | 'follow' | 'continue' | 'unfollow';
function getLabel(action: Action) {
  switch (action) {
    case 'start':
      return translate('course.start.button');
    case 'follow':
      return translate('course.reenroll.button');
    case 'continue':
      return translate('course.in_progress.continue.button');
    case 'unfollow':
      return translate('course.unfollow.button');
    default:
      return translate('course.start.button');
  }
}
type RequiredUserProps = {
  action: 'follow' | 'unfollow';
  userId: number;
};
type OptionalUserProps = {
  action: 'start' | 'continue';
  userId?: number;
};
type Props = RequiredUserProps | OptionalUserProps;
export default function CourseActionButton(t0) {
  const $ = _c(35);
  const {
    action,
    userId
  } = t0;
  let t1;
  if ($[0] !== userId) {
    t1 = {
      userId
    };
    $[0] = userId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    handleFollowCourse,
    handleUnfollowCourse,
    handleContinueCourse,
    loginUrl,
    categoryColor: t2,
    isFollowLoading,
    isUnfollowLoading,
    isContinueLoading
  } = useHeroActions(t1);
  const categoryColor = t2 === undefined ? "initial" : t2;
  let t3;
  if ($[2] !== action) {
    t3 = getLabel(action);
    $[2] = action;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const label = t3;
  if (action === "start" && userId === undefined) {
    let t4;
    if ($[4] !== categoryColor) {
      t4 = {
        background: categoryColor
      };
      $[4] = categoryColor;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== label || $[7] !== loginUrl || $[8] !== t4) {
      t5 = <Button component={Link} href={loginUrl} role="link" style={t4}>{label}</Button>;
      $[6] = label;
      $[7] = loginUrl;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  if (action === "unfollow") {
    const t4 = `${categoryColor} !important`;
    let t5;
    if ($[10] !== categoryColor) {
      t5 = alpha(categoryColor, 0.24);
      $[10] = categoryColor;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    const t6 = `${t5} !important`;
    const t7 = `${categoryColor} !important`;
    let t8;
    if ($[12] !== t6 || $[13] !== t7) {
      t8 = {
        background: t6,
        color: t7
      };
      $[12] = t6;
      $[13] = t7;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    let t9;
    if ($[15] !== t4 || $[16] !== t8) {
      t9 = {
        color: t4,
        "&:hover": t8
      };
      $[15] = t4;
      $[16] = t8;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    let t10;
    if ($[18] !== handleUnfollowCourse || $[19] !== isUnfollowLoading || $[20] !== label || $[21] !== t9) {
      t10 = <Button onClick={handleUnfollowCourse} sx={t9} variant="tertiary" isLoading={isUnfollowLoading}>{label}</Button>;
      $[18] = handleUnfollowCourse;
      $[19] = isUnfollowLoading;
      $[20] = label;
      $[21] = t9;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    return t10;
  }
  const handleClick = action === "continue" ? handleContinueCourse : handleFollowCourse;
  const isLoading = action === "continue" ? isContinueLoading : isFollowLoading;
  const t4 = `${categoryColor} !important`;
  let t5;
  if ($[23] !== categoryColor) {
    t5 = alpha(categoryColor, 0.8);
    $[23] = categoryColor;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  const t6 = `${t5} !important`;
  let t7;
  if ($[25] !== t6) {
    t7 = {
      background: t6
    };
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== t4 || $[28] !== t7) {
    t8 = {
      background: t4,
      "&:hover": t7
    };
    $[27] = t4;
    $[28] = t7;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== handleClick || $[31] !== isLoading || $[32] !== label || $[33] !== t8) {
    t9 = <Button onClick={handleClick} sx={t8} isLoading={isLoading}>{label}</Button>;
    $[30] = handleClick;
    $[31] = isLoading;
    $[32] = label;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  return t9;
}